import { render, staticRenderFns } from "./TariffInfo.vue?vue&type=template&id=93c19fa8&scoped=true&"
import script from "./TariffInfo.vue?vue&type=script&lang=js&"
export * from "./TariffInfo.vue?vue&type=script&lang=js&"
import style0 from "./TariffInfo.vue?vue&type=style&index=0&id=93c19fa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c19fa8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VCol,VIcon,VRow})
